import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Navigation from "./Navigation";
import OnboardingJoyride from "./OnboardingJoyride";
import SessionMonitor from "./SessionMonitor";
import AskJarvis from "./Chat/AskJarvis";
import { useOnboarding } from "../contexts/OnboardingContext";

// Routes where mid-flow popups would disrupt the user experience
const TOUR_BLOCKED_ROUTES = [
  '/app/sop-builder',
  '/app/process-maps',
  '/app/risk-mapping',
  '/app/process-optimization',
  '/app/tasks',
];

const Layout: React.FC = () => {
  const location = useLocation();
  const {
    shouldShowOnboarding,
    completeOnboarding,
    hideOnboarding,
    showOnboarding,
  } = useOnboarding();

  const isBlockedRoute = TOUR_BLOCKED_ROUTES.some(route => location.pathname.startsWith(route));
  const runTour = shouldShowOnboarding() && !isBlockedRoute;

  return (
    <div className="bg-gray-50 overflow-x-hidden h-screen max-h-screen">
      <Header />
      <div className="flex overflow-x-hidden">
        <Navigation />
        <main className="flex-1 p-6 overflow-x-hidden h-[calc(100vh-88px)] max-h-screen">
          <Outlet />
        </main>
      </div>

      <OnboardingJoyride run={runTour} onFinish={completeOnboarding} />
      <SessionMonitor />
      <AskJarvis />
    </div>
  );
};

export default Layout;
